import { createRoute } from "@tanstack/react-router";
import { RoleGuard } from "@/components/auth/RoleGuard";
import { ErrorsRegistry } from "@/pages/registries/ErrorsRegistry";
import { Route as RootRoute } from "./__root";

/**
 * TM-28f9536d — error console moved from `/errors` to `/admin/errors`
 * (admin-only). The old `/errors` route is gone entirely; a hit on the
 * legacy URL falls through to the root NotFoundPage (no redirect — Dmitri
 * explicitly asked for 404, not 301/302).
 */
export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/admin/errors",
  component: () => (
    <RoleGuard action="error_view">
      <ErrorsRegistry />
    </RoleGuard>
  ),
});
